import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPostDownload, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

export const GetMigrateEfinPage = () => {
  const url = `${API_ROOT}/v1/accounting/migrate/efin`
  return doGet(url)
}

export const GetMigrateEfin = (projectCode, periodNo) => {
  const url = `${API_ROOT}/v1/accounting/migrate/efin/${projectCode}/${periodNo}`
  return doGet(url)
}

export const SaveMigrateEfin = (request) => {
  const url = `${API_ROOT}/v1/accounting/migrate/efin`
  return doPost(url, request)
}

export const GetMigrateBorrowAdvancePage = () => {
  const url = `${API_ROOT}/v1/accounting/migrate/borrow-advance`
  return doGet(url)
}

export const SaveMigrateBorrowAdvance = (request) => {
  const url = `${API_ROOT}/v1/accounting/migrate/borrow-advance`
  return doPost(url, request)
}

export const ImportMigrateBorrowAdvance = (request) => {
  const url = `${API_ROOT}/v1/accounting/migrate/borrow-advance/import`
  return doPostFiles(url, request)
}

export const GetMigrateBorrowAdvanceEfin = (projectCode, periodNo) => {
  const url = `${API_ROOT}/v1/accounting/migrate/borrow-advance/${projectCode}/${periodNo}`
  return doGet(url)
}

export const ExprotMigrateBorrowAdvance = (request) => {
  const url = `${API_ROOT}/v1/accounting/migrate/borrow-advance/export`
  return doPostDownload(url, request)
}
